import inputConstants from '../constants';
import computeClassName from '../../../../../../utils/computeClassName';


const constants = Object.freeze({
  CLASSNAME_BASE: 'CCFormInputLabel absolute top-0 left-4 -z-1 font-normal transition-transform',
  CLASSNAME_INPUT_IS_DISABLED: {
    true: 'text-cc-muted-contrast',
    false: 'text-cc-primary-contrast'
  }
});

const propsDefaults = Object.freeze({
  isFloating: true,
});

export default function CCFormInputLabel(
  {
    isInputDisabled,
    className,
    children
  }) {
  const computedClassName = computeClassName(className);
  return !!children ?
    <span aria-hidden="true" className={computedClassName}>{children}</span> :
    null;
}
